import AvatarUser, { AvatarUserProps } from "./AvatarUser"

interface AvatarViewProps extends AvatarUserProps {
  floatingIcon?: any
}

function AvatarView(props: AvatarViewProps) {
  const { floatingIcon, ...rest } = props

  const Icon = props.floatingIcon || IconMageUserFill

  return (
    <button className="group relative">
      <AvatarUser {...rest} />
      <div className={`absolute inset-0 rounded-full bg-black/0 transition-opacity duration-300 ease-in-out group-hover:bg-black/10`} />
      <Icon className={`bg-background absolute right-0 bottom-0 size-[25px] rounded-full p-1 text-secondary shadow-lg`} />
    </button>
  )
}

export default AvatarView
